import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
import { packItems } from '../data/salesContent';
import { images } from '../data/siteConfig';
export function OfferSection() {
  return <section id="offer" className="scroll-mt-4 bg-navy py-16 lg:py-24" data-id="element-127" data-mp="8lu8e6onpcuv">
      <div className="mx-auto max-w-5xl px-5" data-id="element-128" data-mp="def114vttjwt">
        <h2 className="text-center font-display text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-129" data-mp="dg8306vhvfyh">
          Your Complete Pool Care Pack
        </h2>

        <div className="mt-10 grid items-center gap-10 rounded-3xl bg-white/[0.06] p-6 ring-1 ring-white/10 sm:p-10 lg:grid-cols-2" data-id="element-130" data-mp="mdigzzzp5j73">
          <img src={images.bundleMockup} alt="The main guide and all five bonus PDFs" className="w-full rounded-2xl" data-id="element-131" data-mp="rbtuckp7abu2" />

          <div data-id="element-132" data-mp="2t6kw62h2c0q6">
            <ul className="space-y-3" data-id="element-133" data-mp="2t7454toqjes2">
              {packItems.map(item => <li key={item} className="flex items-start gap-3 text-lg text-white" data-id="element-134" data-mp="2y55o7em5ve3j">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-aqua" data-id="element-135" data-mp="12ojy0hic0coe">
                    <CheckIcon className="h-4 w-4 text-navy" strokeWidth={3} aria-hidden="true" data-id="element-136" data-mp="xv8qsf9lxtvy" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 border-t border-white/15 pt-6" data-id="element-137" data-mp="oxomsykd1jhn">
              <p className="font-display text-5xl font-extrabold text-white" data-id="element-138" data-mp="1lmmiqk3ujnge">
                $33 <span className="text-xl font-bold text-white/70" data-id="element-139" data-mp="1gnjdoznv9h8f">USD</span>
              </p>
              <div className="mt-6" data-id="element-140" data-mp="1clofi418fjyv">
                <BuyButton label="GET THE COMPLETE PACK — $33" fullWidth data-id="element-141" data-mp="1ckn2hu0nonei" />
              </div>
              <p className="mt-4 text-center text-sm text-white/75" data-id="element-142" data-mp="17ljuq1tak32u">
                Digital products only. No physical books will be shipped.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-center" data-id="element-143" data-mp="3sc14dnfrpikr">
          <p className="inline-flex items-center gap-2.5 rounded-full border border-aqua/40 bg-aqua/10 px-5 py-2.5 text-sm font-semibold text-white sm:text-base" data-id="element-144" data-mp="3ttzs48y1keo7">
            <GlobeIcon className="h-5 w-5 text-aqua" aria-hidden="true" data-id="element-145" data-mp="2n6jik0x5d9n" />
            Pay in Your Local Currency
          </p>
        </div>
      </div>
    </section>;
}